
import OnboardlistCategory from './OnboardlistCategory'
import OnbordingList from './OnbordingList'
import OnboardFolder from './OnboardFolder'
const routes = [
  {
    type: 'collapse',
    key: 'OnboardlistCategory',
    route: '/',
    component: <OnboardFolder />,
  },
  {
    type: 'collapse',
    key: 'OnboardlistCategory',
    route: '/:page_id',
    component: <OnbordingList />,
  },
  // {
  //   type: 'collapse',
  //   key: 'home',
  //   route: '/:folder_id/:page_id/:type',
  //   component: <OnbordingList />,
  // },

]

export default routes
